/**
 * Utility functions for parsing meta tags
 *
 * Copyright (c) 2022 Propellant Software Corp
 * Author: Kelvin Nguyen
 */

export const isCrawler = () => {
  const crawlerMeta = document.querySelector("meta[data-name='crawler']")?.getAttribute('content')

  return crawlerMeta && crawlerMeta === 'true'
}
